import localeKK from '@angular/common/locales/kk';
import localeRu from '@angular/common/locales/ru';
import {APP_INITIALIZER, ErrorHandler, NgModule} from "@angular/core";
import { PageFindToursComponent } from './pages/find-tours/find-tours.component';
import {AnalyticService} from './services/analytic.service';
import {ApiService} from './services/api.service';
import {AppComponent} from './app.component';
import {APP_CONFIG} from './config/app.config';
import {BrowserModule} from '@angular/platform-browser';
import {ClickOutsideModule} from 'ng-click-outside';
import {ContentModalService} from './services/content-modal.service';
import {EventBusService} from './services/event-bus.service';
import {FilterComponent} from './components/filters/filter/filter.component';
import {FilterDefaultComponent} from './components/filters/filter/default/filter-default.component';
import {FilterHorizontalComponent} from "./components/filters/filter/horizontal/filter-horizontal.component";
import {FilterNightsComponent} from './components/filters/filter/nights/filter-nights.component';
import {FilterSealinesComponent} from './components/filters/filter/sealines/filter-sealines.component';
import {FilterStarsComponent} from './components/filters/filter/stars/filter-stars.component';
import {FiltersComponent} from './components/filters/filters.component';
import {GmapLoaderService} from './services/gmap-loader.service';
import {GuideBannersComponent} from './components/guide-banners/guide-banners.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {HelpPopoverComponent} from './components/help-popover/help-popover.component';
import {HelpPopoverService} from './services/help-popover.service';
import {HotelNameSearchComponent} from './components/hotel-name-search/hotel-name-search.component';
import {HotelRatingComponent} from './components/hotel-rating/hotel-rating.component';
import {HotelServicesComponent} from './components/tours/tour-info/hotel-services/hotel-services.component';
import {HotelStarsComponent} from './components/hotel-stars/hotel-stars.component';
import {HotelViewCountComponent} from "./components/hotel-view-count/hotel-view-count.component";
import {IncorrectFiltersComponent} from './components/filters/incorrect/incorrect-filters.component';
import {JsonInterceptor} from 'src/json.interceptor';
import {LOCALE_ID} from '@angular/core';
import {MapPopupHotelComponent} from './components/tours-map/popup/map-popup-hotel.component';
import {MobileFilterSelectedValuesPipe} from './components/pipes/mobile-filter-selected-values.pipe';
import {NearDatesWithPriceService} from './services/near-dates-with-price.service';
import {NgxInViewportModule} from '@ngx-lite/in-viewport';
import {NumberInputDirective} from './directives/number-input.directive';
import {PluralizeModule} from './components/pipes/pluralize/pluralize.module';
import {SafePipe} from './components/pipes/safe.pipe';
import {SealinesModule} from './components/pipes/sealines/sealines.module';
import {SearchProgressLinearComponent} from "./components/search-progress-linear/search-progress-linear.component";
import {TemplateReplaceModule} from "./components/pipes/trmplate-replace/template-replace.module";
import {TemplateReplacePipe} from "./components/pipes/trmplate-replace/template-replace.pipe";
import {TimeoutPopupComponent} from './components/timeout-popup/timeout-popup.component';
import {TimeoutPopupService} from './services/timeout-popup.service';
import {TooltipDirective} from './directives/tooltip.directive';
import {TourCallbackComponent} from './components/tours/tour-callback/tour-callback.component';
import {TourCompareComponent} from './components/tours/tour-compare/tour-compare.component';
import {TourComponent} from './components/tours/tour/tour.component';
import {TourCreditComponent} from './components/tours/tour-credit/tour-credit.component';
import {TourCreditDropdownComponent} from './components/tours/tour-credit/dropdown/tour-credit-dropdown.component';
import {TourCreditDropdownService} from './services/tour-credit-dropdown.service';
import {TourFilterHelpComponent} from './components/tours/tour-filter-help/tour-filter-help.component';
import {TourImageMobileComponent} from './components/tours/tour-image/tour-image.component.mobile';
import {TourIncludeComponent} from './components/tours/tour-include/tour-include.component';
import {TourInfoComponent} from './components/tours/tour-info/tour-info.component';
import {TourOnlineBookingComponent} from './components/tours/tour-online-booking/tour-online-booking.component';
import {TourPhoneComponent} from './components/tours/tour-phone/tour-phone.component';
import {TourPricesComponent} from './components/tours/tour-prices/tour-prices.component';
import {TourPricesValueComponent} from './components/tours/tour-prices/value/tour-prices-value.component';
import {TourRecommendationsComponent} from './components/tours/tour-recommendations/tour-recommendations.component';
import {TourSearchProgressComponent} from './components/tours/tour-search-progress/tour-search-progress.component';
import {TourSubscriptionComponent} from './components/tours/tour-subscription/tour-subscription.component';
import {TourSurchargesComponent} from './components/tours/tour-surcharges/tour-surcharges.component';
import {ToursCompareService} from './services/tours-compare.service';
import {ToursNotFoundComponent} from './components/tours/tours-not-found/tours-not-found.component';
import {ToursSortComponent} from './components/filters/sorts/tours-sort.component';
import {ToursStateService} from './services/tours-state.service';
import {
  ToursVariantNotFoundComponent
} from './components/tours/tours-variant/not-found/tours-variant-not-found.component';
import {WindowRefService} from './services/window-ref.service';
import {provideNgxMask} from 'ngx-mask';
import {registerLocaleData} from '@angular/common';
import {TourLoaderComponent} from "./components/tours/tour-loader/tour-loader.component";
import {ToursTotalComponent} from "./components/tours-total/tours-total.component";
import {ToursMapComponent} from "./components/tours-map/tours-map.component";
import {ToursComponent} from "./components/tours/tours.component";
import {HotelToursComponent} from "./components/hotel-tours/hotel-tours.component";
import {HttpSearchService} from "./services/search/search-requests.service";
import {ShortSearchParamsComponent} from "./components/hotel-tours/short-search-params/short-search-params.component";
import {HotelToursFiltersComponent} from "./components/hotel-tours/filters/filters.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HotelToursSearchService} from "./services/search/hotel-tours-search.service";
import {HotelPriceCalendarComponent} from "./components/hotel-tours/short-search-params/calendar/calendar.component";
import {
  PageHotelToursListComponent
} from "./pages/hotel-tours-list/hotel-tours-list.component";
import {PageManagerOfferComponent} from "./pages/manager-offer/manager-offer.component";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "./config/hotel-tours-list-page.config";

registerLocaleData(localeRu, 'ru');
registerLocaleData(localeKK, 'kk');

@NgModule({
  declarations: [
    HelpPopoverComponent,
    MobileFilterSelectedValuesPipe,
    NumberInputDirective,
    TimeoutPopupComponent,
    TooltipDirective,
    TourCompareComponent,
    TourPhoneComponent,
    TourSearchProgressComponent,
    TourSubscriptionComponent,
    TourSurchargesComponent,
    ToursVariantNotFoundComponent,
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ClickOutsideModule,
    FilterComponent,
    FilterDefaultComponent,
    FilterHorizontalComponent,
    FilterNightsComponent,
    FilterSealinesComponent,
    FilterStarsComponent,
    FiltersComponent,
    GuideBannersComponent,
    HotelNameSearchComponent,
    HotelRatingComponent,
    HotelServicesComponent,
    HotelStarsComponent,
    NgxInViewportModule,
    PluralizeModule,
    SafePipe,
    SealinesModule,
    TemplateReplaceModule,
    TemplateReplacePipe,
    TourCallbackComponent,
    TourComponent,
    TourCreditComponent,
    TourCreditDropdownComponent,
    TourImageMobileComponent,
    TourIncludeComponent,
    TourInfoComponent,
    TourOnlineBookingComponent,
    TourPricesComponent,
    TourPricesValueComponent,
    ToursNotFoundComponent,
    ToursSortComponent,
    HotelViewCountComponent,
    IncorrectFiltersComponent,
    TourFilterHelpComponent,
    TourLoaderComponent,
    ToursTotalComponent,
    ToursMapComponent,
    ToursComponent,
    HotelToursComponent,
    ShortSearchParamsComponent,
    HotelToursFiltersComponent,
    HotelPriceCalendarComponent,
    PageHotelToursListComponent,
    PageManagerOfferComponent,
    PageFindToursComponent,
    MapPopupHotelComponent,
    SearchProgressLinearComponent
  ],
  providers: [
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      multi: true,
    },
    {provide: LOCALE_ID, useValue: 'ru'},
    {provide: HTTP_INTERCEPTORS, useClass: JsonInterceptor, multi: true},
    {provide: APP_CONFIG, useClass: HotelToursPageConfig},
    {provide: HOTEL_TOURS_PAGE_CONFIG, useClass: HotelToursPageConfig},
    HttpSearchService,
    ApiService,
    EventBusService,
    TimeoutPopupService,
    WindowRefService,
    GmapLoaderService,
    ContentModalService,
    TourCreditDropdownService,
    HelpPopoverService,
    ToursCompareService,
    AnalyticService,
    NearDatesWithPriceService,
    ToursStateService,
    HotelToursSearchService,
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask()
  ],
  exports: [
    HotelViewCountComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}

export function errorHandlerFactory() {
  return new ErrorHandler();
}
